import Immutable from "seamless-immutable";

const initialState = Immutable({});

const PaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default PaymentReducer;
